module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"caption":"Trendbewertung"},"en":{"caption":"Trend evaluation"}}')
  delete Component.options._Ctor
}
